import { useState } from 'react';
import axiosService from '../../../../service_v2/common/axios-service';

export const useUpdatePanelist = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(false);

  const updatePanelistHook = async (panelist, handleUpdate) => {
    setLoading(true);
    setError(null);
    setSuccess(false);

    try {
      const response = await axiosService.put(
        `${process.env.REACT_APP_MP_CF_GEN2_API_BASE_URL}qalbox-admin-event-panelist/v1/update/`,
        {panelist}
      );

      const json = response?.data;
      if (json?.payload) {
        setSuccess(true);
        handleUpdate(json?.payload);
      } else {
        setError("Failed to update panelist");
      }
      
    } catch (error) {
      setError("An error occurred while updating the panelist");
    } finally {
      setLoading(false);
    }
  };

  return [ updatePanelistHook, loading, error, success ];
};